import React, { lazy } from "react";
import { withTranslation, Trans } from "react-i18next";
import { Box } from "@mui/material";
import { ElipseTop, ElipseBottom } from "../utils/theme.js";
import Devin from "../assets/Team/Devin.webp";
import Natayra from "../assets/Team/Natayra.webp";
import Jay from "../assets/Team/Jay.webp";
import Ali from "../assets/Team/Ali.webp";
import Roland from "../assets/Team/Roland.webp";
import Driton from "../assets/Team/Driton.webp";
import Maria from "../assets/Team/Maria.webp";

const TeamWeb = lazy(() => import("./WebComponents/TeamWeb"));
const TeamMobile = lazy(() => import("./MobileComponents/TeamMobile"));

const TeamComponent = () => {
  const team = [
    {
      name: <Trans>{"teamComponent.ali.name"}</Trans>,
      title: <Trans>{"teamComponent.ali.title"}</Trans>,
      image: Ali,
      linkedin: "https://www.linkedin.com/in/ali-habbabeh/",
    },
    {
      name: <Trans>{"teamComponent.roland.name"}</Trans>,
      title: <Trans>{"teamComponent.roland.title"}</Trans>,
      image: Roland,
      linkedin: "https://www.linkedin.com/in/rolandkalocsaven/",
    },
    {
      name: <Trans>{"teamComponent.driton.name"}</Trans>,
      title: <Trans>{"teamComponent.driton.title"}</Trans>,
      image: Driton,
      linkedin: "https://www.linkedin.com/in/driton-selami/",
    },
    {
      name: <Trans>{"teamComponent.devin.name"}</Trans>,
      title: <Trans>{"teamComponent.devin.title"}</Trans>,
      image: Devin,
      linkedin: "https://www.linkedin.com/in/devin-wyrsch-2071a2204",
    },
    {
      name: <Trans>{"teamComponent.natayra.name"}</Trans>,
      title: <Trans>{"teamComponent.natayra.title"}</Trans>,
      image: Natayra,
      linkedin: "https://www.linkedin.com/in/natayra/",
    },
    {
      name: <Trans>{"teamComponent.jay.name"}</Trans>,
      title: <Trans>{"teamComponent.jay.title"}</Trans>,
      image: Jay,
      linkedin: "https://www.linkedin.com/in/jay-asaad-a55520211/",
    },
    {
      name: <Trans>{"teamComponent.maria.name"}</Trans>,
      title: <Trans>{"teamComponent.maria.title"}</Trans>,
      image: Maria,
      linkedin: "https://www.linkedin.com/in/maria-alshamas-437052210/",
    },
  
  ];

  return (
    <Box sx={{ backgroundColor: "secondary.main" }}>
      <ElipseTop></ElipseTop>
      <TeamWeb team={team} display={{ xs: "none", md: "flex" }} />
      <TeamMobile team={team} display={{ xs: "flex", md: "none" }} />
      <ElipseBottom></ElipseBottom>
    </Box>
  );
};
export default withTranslation()(TeamComponent);
